import './Warn.css';

import PropTypes from 'prop-types';

import WarnIcon from './warn-icon.png';

const Warn = ({ className, children, icon }) => {
  Warn.propTypes = {
    children: PropTypes.node,
    icon: PropTypes.string,
    className: PropTypes.string
  };

  return (
    <div className={className ? `${className} warn-container` : 'warn-container'}>
      <span className="warn-img-container">
        <img alt="!" className="warn-icon" src={icon || WarnIcon} />
      </span>
      {children || null}
    </div>
  );
};

export default Warn;
